module.exports = __webpack_public_path__ + "media/images/client-19-b8d1282aa1a5f37d6d7d927d3f810d28.png";